import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

import { ImportOrdersContext } from './ImportOrders.context'
import { SheetResult } from './UploadFileProgressBar/UploadFileStandard/UploadFileStandard.types'

type ValidatedOrder = {
  id: string
  poNumber: string
}

type Order = {
  data?: Blob
  error: string
  filename: string
  orders: ValidatedOrder[]
  sheetResults?: SheetResult[]
}

export type ImportOrdersStandardContextProps = {
  clearSecondStepStandardValues: () => void
  importedOrders: Order[]
  setImportedOrders: Dispatch<SetStateAction<Order[]>>
  poNumber: string
  setPoNumber: Dispatch<SetStateAction<string>>
  includedRetailerFound: boolean | undefined
  setIncludedRetailerFound: Dispatch<SetStateAction<boolean | undefined>>
  disableRetailerDropdown: boolean
  setDisableRetailerDropdown: Dispatch<SetStateAction<boolean>>
}

const ImportOrdersStandardContext =
  createContext<ImportOrdersStandardContextProps>(
    {} as ImportOrdersStandardContextProps,
  )

type ImportOrdersStandardContextProviderProps = {
  children: ReactNode
}
const ImportOrdersStandardContextProvider: FC<
  ImportOrdersStandardContextProviderProps
> = ({ children }) => {
  const [importedOrders, setImportedOrders] = useState<Order[]>([])
  const [poNumber, setPoNumber] = useState<string>('')
  const [includedRetailerFound, setIncludedRetailerFound] = useState<
    boolean | undefined
  >(undefined)
  const [disableRetailerDropdown, setDisableRetailerDropdown] = useState(false)

  const {
    setWarehouse,
    setOrderType,
    setRetailerWarehousesOptions,
    setRetailer,
    setConnectedAccountsOptions,
    setRetailerSearchText,
    setDoorsOptions,
    setDoor,
  } = useContext(ImportOrdersContext)

  const clearSecondStepStandardValues = () => {
    setConnectedAccountsOptions([])
    setDoorsOptions([])
    setRetailerWarehousesOptions([])
    setRetailer(null)
    setDoor(null)
    setPoNumber('')
    setRetailerSearchText('')
    setIncludedRetailerFound(undefined)
    setDisableRetailerDropdown(false)
    setWarehouse(null)
    setOrderType(null)
  }

  return (
    <ImportOrdersStandardContext.Provider
      value={{
        clearSecondStepStandardValues,
        importedOrders,
        setImportedOrders,
        poNumber,
        setPoNumber,
        includedRetailerFound,
        setIncludedRetailerFound,
        disableRetailerDropdown,
        setDisableRetailerDropdown,
      }}
    >
      {children}
    </ImportOrdersStandardContext.Provider>
  )
}

export { ImportOrdersStandardContext, ImportOrdersStandardContextProvider }
